import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import reduxThunk from 'redux-thunk';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {combineReducers} from 'redux';
import AuthReducer from './layout/user/store/reducers/index';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

const reducers = combineReducers({...AuthReducer})

//uncomment for development
// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//uncomment for production
const composeEnhancers = compose;

const store = createStore(
    reducers, 
    composeEnhancers(applyMiddleware(reduxThunk))
    );

    const theme = createMuiTheme({
      palette: {
        primary: {
          main: '#3F92FF', // your brand color
        },
        secondary: {
          main: '#FF4081', // your brand color
        },
        error: {
          dark: '#f44336', // standard Material-UI error red
          main: '#f44336', // standard Material-UI error red
          light: '#ffebee', // your custom light shade (optional)
        },
        success: {
          main: '#4CAF50',   // Material-UI Green 500
          light: '#81C784',  // Green 300
          dark: '#388E3C',   // Green 700
          contrastText: '#fff'
        },
        warning: {
          main: '#FF9800',   // Material-UI Orange 500
          light: '#FFB74D',  // Orange 300
          dark: '#F57C00',   // Orange 700
          contrastText: '#fff'
        },
        review: {
          approve: '#255d00', 
          reject: '#FF9800', // orange for reject
        },
        autoComplete: {
          light: '#e3f2fd', // #e0f7fa #e3f2fd light shade for autocomplete background
        },
      },
      overrides: {
          MuiTooltip: {
              tooltip: {
                  fontSize: "12px",
              },
          },
      },
        typography: {
          fontFamily: [
            'Open Sans',
            'Arial',
            'Sans-Serif'
          ].join(','),
        },
        fontSize: '11px'
      });

ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider theme={theme}>
            <App />
        </ThemeProvider>
    </Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();


